import axios from "axios";

/*
    axios 인스턴스를 생성합니다.
    생성할때 사용하는 옵션들 (baseURL, timeout, headers 등)은 다음 URL에서 확인할 수 있습니다.
    https://github.com/axios/axios 의 Request Config 챕터 확인
*/
const instance = axios.create({
  method: "PUT",
  baseURL: "https://emons.co.kr/",
  // baseURL: '/RESTful/',
  timeout: 50000,
  headers: {
    "X-Requested-With": "XMLHttpRequest",
    Accept: "application/json",
    "Content-Type": "application/json;charset=UTF-8",
    // "Cache-Control": "private, max-age=3600",
  },
  responseType: "json",
  responseEncoding: "utf8",
  maxRedirects: 0,
});

// /*
//     1. 요청 인터셉터를 작성합니다.
//     2개의 콜백 함수를 받습니다.

//     1) 요청 바로 직전 - 인자값: axios config
//     2) 요청 에러 - 인자값: error
// */
// instance.interceptors.request.use(
//   (config) => {
//     // 요청 바로 직전
//     // axios 설정값에 대해 작성합니다.
//     return config;
//   },
//   (error) => {
//     // 요청 에러 처리를 작성합니다.
//     return Promise.reject(error);
//   }
// );

// /*
//     2. 응답 인터셉터를 작성합니다.
//     2개의 콜백 함수를 받습니다.

//     1) 응답 정성 - 인자값: http response
//     2) 응답 에러 - 인자값: http error
// */
// instance.interceptors.response.use(
//   (response) => {
//     /*
//         http status가 200인 경우
//         응답 바로 직전에 대해 작성합니다.
//         .then() 으로 이어집니다.
//     */
//     return response;
//   },

//   (error) => {
//     /*
//         http status가 200이 아닌 경우
//         응답 에러 처리를 작성합니다.
//         .catch() 으로 이어집니다.
//     */
//     return Promise.reject(error);
//   }
// );

// 생성한 인스턴스를 익스포트 합니다.
export default instance;
